<template>
  <div class="NumberKeySlider">
    <!-- <div class="NumberKeySlider_before"><div class="NumberKeySlider_before_shape"></div></div> -->
    <swiper :options="swiperOption" ref="mySwiper" class="NumberKeySlider_swiper">
      <swiper-slide class="NumberKeySlider_slide" v-for="(slide, index) in data" :key="index">
        <div class="NumberKeySlider_value" v-html="slide.chiffre"></div>
        <div class="NumberKeySlider_description" v-html="slide.description"></div>
        <img class="NumberKeySlider_illustration" :src="slide.illustration" />
      </swiper-slide>

      <div class="NumberKeySlider_navigation"  slot="pagination"></div>

    </swiper>
  </div>
</template>

<script>
  export default {
    name: "NumberKeySlider",
    props: [ 'data' ],
    data() {
      return {
        swiperOption: {
          slidesPerView: 'auto',
          grabCursor: true,
          spaceBetween: 5,
          centeredSlides: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.NumberKeySlider_navigation'
          }
        }
      }
    }
  }
</script>

<style lang="stylus">
.NumberKeySlider

  position relative
  width 390px
  height 430px
  margin auto
  margin-top 20px
  text-align: center;

  @media $medium

    margin-top 80px

  @media $small

    margin-left 0px
    margin-right 0px
    width 100%
    height auto
    margin-top 40px

  &_before

    position absolute
    top 0px
    left 10%
    height 100%
    width 100%
    z-index -1

    &_shape

      left 0px
      position absolute
      top 0px
      height 100%
      width 100%
      background-color white
      border-radius 5px
      transform rotate(8deg)
      box-shadow: 0 2px 24px 0 rgba(0,0,0,0.10);

    @media $small

      display none
      
  .swiper-wrapper

    align-items stretch
    flex-direction row

  &_swiper

    background-color white
    width 100%
    height 100%
    box-sizing border-box
    border-radius 5px
    box-shadow: 0 2px 24px 0 rgba(0,0,0,0.10);
    position relative

    @media $small

      background-color transparent
      height auto
      overflow visible!important
      border-radius 0px
      box-shadow none

  .NumberKeySlider_navigation

    position absolute
    left 50%!important
    transform translateX(-50%)!important
    bottom 25px!important
    z-index 2

    @media $small

      display none

    .swiper-pagination-bullet 

      background $s1!important
      
    .swiper-pagination-bullet.swiper-pagination-bullet-active

      background $blue!important

  &_slide

    width 100%
    padding 40px 40px 30px 40px
    box-sizing border-box
    overflow hidden
    display flex
    flex-direction column
    align-items center
    justify-content space-between
    height auto!important

    @media $small

      background-color white
      min-height 355px
      max-width 325px
      width 75%!important
      box-sizing border-box
      border-radius 5px
      box-shadow: 0 2px 24px 0 rgba(0,0,0,0.10);

    &.swiper-slide-active

      .NumberKeySlider

        &_illustration

          opacity 1
          transform scale(1)

        &_value, &_description

          transform translateX(0px) rotate(0deg)
          opacity 1

    &.swiper-slide-prev

      .NumberKeySlider

        &_value, &_description

          transform translateX(-60px) rotate(-5deg)

  &_illustration

    width 80%
    display block
    margin auto auto 0px auto
    opacity 0
    transform scale(0.8)
    transition 0.6s $ease
    transition-delay 0.25s

  &_value

    font-family: $f-title
    font-weight 800
    font-size: 70px;
    width 100%
    letter-spacing: -1.05px;
    line-height: 70px;
    margin-bottom 10px
    opacity 0
    transform translateX(60px) rotate(5deg)
    transition 1s $ease
    transition-delay 0.05s

  &_description

    margin 0px auto auto auto
    font-size: 18px;
    color $s1
    width 100%
    opacity 0
    line-height: 24px;
    transform translateX(60px) rotate(5deg)
    transition 1s $ease
    transition-delay 0.2s

    @media $medium

      font-size: 14px;
      line-height: 22px;

.ie

  .NumberKeySlider

    &_illustration

      height 140px

    &_slide

      width calc(100% - 80px)!important
      padding: 0px 0px!important
      height calc(100% - 70px)!important
      margin auto auto!important
</style>